import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MultiFormsComponent } from 'src/app/ui/multi-forms/multi-forms.component';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { ProductsService } from './service/products.service';
import { Product } from './models/product';
import { LovApiService } from 'src/app/services/lov-api.service';
import { SortObject } from 'src/app/models/sortObject';
@Component({
  selector: 'nejo-order-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  providers: [ProductsService],
})
export class ProductsComponent implements OnInit {
  public data: Product[] = [];
  public user_id;
  public form: UntypedFormGroup;
  public forms = new UntypedFormArray([]);
  public submitFailed = false;
  public products: AsyncDropdown[] = [];
  public productsLoading: boolean = false;
  public openedId: string;
  @ViewChild(MultiFormsComponent) multiForm: MultiFormsComponent;

  constructor(
    private router: Router,
    public productsService: ProductsService,
    private lovApiService: LovApiService,
  ) {}

  async ngOnInit() {
    var urlFragments = this.router.url.split('/');
    this.user_id = urlFragments[2];
    this.openedId = urlFragments[urlFragments.findIndex(el => el === 'product') + 1];
  }

  initNewForm = () => {
    return this.initForm(new Product());
  };

  initForm = (data: Product) => {
    this.initDropdowns(data);
    let formGroup = new UntypedFormGroup({
      identifier: new UntypedFormControl(data.identifier),
      quantity: new UntypedFormControl(data.quantity, [Validators.required]),
      code: new UntypedFormControl({ value: data.product?.code, disabled: true }),
      product: new UntypedFormControl(data.product, [Validators.required]),
    });

    return formGroup;
  };

  initDropdowns(data: Product) {
    this.products.push(data.product || new AsyncDropdown());
  }

  reformatSingleHours(hours: number) {
    return hours && Number(hours) >= 0
      ? '[ ' + Number(hours).toFixed(2) + 'h | ' + Number(hours / 8).toFixed(2) + 'd ]' 
      : '[ 0h | 0d ]';
  }

  async addTitleToCollapsable(forms) {
    forms.controls.forEach((item) => (item.name = `${item.value.product.name} ` + `${this.reformatSingleHours(item.value.quantity)}`));
  }

  addNewSection() {
    this.multiForm.addNewSection();
  }

  async fetchProducts() {
    this.products = [];
    this.productsLoading = true;
    var sort: SortObject[] = [{ prop: 'name', dir: 'asc' }];
    this.products = await this.lovApiService.getDropdownValues('order', 'product', sort);
    this.productsLoading = false;
  }

  patchCode(product, form) {
    form.controls.code.patchValue(product.code);
  }
}
